import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { api, formatApiError } from "../lib/api";
import { Card } from "./ui/card";
import { WithdrawalsList } from "./WithdrawalsList";
import { brl } from "./PurchaseDialog";

export const AdminWithdrawals = () => {
  const [items, setItems] = useState(null);
  const load = useCallback(() => {
    api.get("/admin/withdrawals").then((r) => setItems(r.data)).catch((e) => toast.error(formatApiError(e)));
  }, []);
  useEffect(() => {
    load();
    const t = setInterval(load, 15000);
    return () => clearInterval(t);
  }, [load]);
  const resolve = async (w, action) => {
    if (action === "approve" || action === "reject") {
      let reason = "";
      if (action === "approve" && !window.confirm(`Aprovar e enviar ${w.net_amount.toLocaleString("pt-BR", { style: "currency", currency: "BRL" })} via Pix para ${w.pix_key}?`)) return;
      if (action === "reject") { reason = window.prompt("Motivo da rejeição (o valor volta ao saldo do usuário):"); if (reason === null) return; }
      try { await api.post(`/admin/withdrawals/${w.id}/review`, { action, reason }); toast.success(action === "approve" ? "Aprovado — Pix enviado" : "Saque rejeitado e estornado"); }
      catch (e) { toast.error(formatApiError(e)); }
      load();
      return;
    }
    const msg = action === "refund" ? "Estornar o valor ao saldo do usuário? Use só se o Pix NÃO saiu na Bitflow." : "Confirmar que o Pix já foi pago na Bitflow?";
    if (!window.confirm(msg)) return;
    try { await api.post(`/admin/withdrawals/${w.id}/resolve`, { action }); toast.success("Saque atualizado"); load(); }
    catch (e) { toast.error(formatApiError(e)); }
  };
  const paid = (items || []).filter((w) => w.status === "completed");
  const pending = (items || []).filter((w) => w.status === "pending_approval").length;
  return (
    <Card className="p-6" data-testid="admin-withdrawals">
      <div className="flex flex-wrap items-end justify-between gap-3 mb-4">
        <div>
          <div className="font-display text-lg font-bold">Saques via Pix (Bitflow)</div>
          <p className="text-xs text-muted-foreground">Ao aprovar, o valor líquido é enviado automaticamente pela Bitflow para a chave Pix do perfil do usuário. Saques rejeitados ou que falham voltam ao saldo do usuário.</p>
          <p className="text-xs mt-1" data-testid="admin-withdrawals-pending-count"><b className="text-sky-500">{pending}</b> aguardando aprovação</p>
        </div>
        <div className="text-xs text-muted-foreground" data-testid="admin-withdrawals-totals">
          Pago: <b className="font-mono text-foreground">{brl(paid.reduce((a, w) => a + w.net_amount, 0))}</b> ·
          Taxas: <b className="font-mono text-foreground">{brl(paid.reduce((a, w) => a + w.fee, 0))}</b>
        </div>
      </div>
      {!items ? <p className="text-sm text-muted-foreground">Carregando...</p> : <WithdrawalsList items={items} admin testid="admin-withdrawals-list" onResolve={resolve} />}
    </Card>
  );
};
